import { BaseGraphqlLayer } from '@core/base';
import { ICreateCompletionGeminiInputType } from '@introspection/index';
import { Injectable } from '@rxdi/core';
import { map } from 'rxjs/operators';

@Injectable()
export class AiService extends BaseGraphqlLayer {
  createCompletion(payload: ICreateCompletionGeminiInputType) {
    return this.mutate({
      mutation: 'create-completion-gemini.mutation.graphql',
      variables: {
        payload,
      },
    }).pipe(map((res) => res.data.createCompletionGemini));
  }

  /** ADMIN: a full article draft (MiniMax), grounded in the given research sources. */
  createPostDraft(title: string, notes: string, sources: { url: string; title: string; excerpt: string }[] = []) {
    return this.mutate({
      mutation: 'create-post-draft.mutation.graphql',
      variables: { title, notes, sources },
    }).pipe(map((res) => res.data.createPostDraft));
  }

  /** ADMIN: web search (Brave or Tavily, configured on the API). */
  searchWeb(query: string) {
    return this.mutate({
      mutation: 'search-web.mutation.graphql',
      variables: { query },
    }).pipe(map((res) => res.data.searchWeb ?? []));
  }

  /** ADMIN: a public page reduced to readable text. */
  fetchSource(url: string) {
    return this.mutate({
      mutation: 'fetch-source.mutation.graphql',
      variables: { url },
    }).pipe(map((res) => res.data.fetchSource));
  }
}
